import { render, staticRenderFns } from "./ExportJournal.vue?vue&type=template&id=0cbc41cc&scoped=true"
import script from "./ExportJournal.vue?vue&type=script&setup=true&lang=js"
export * from "./ExportJournal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbc41cc",
  null
  
)

export default component.exports